import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
}
export function Button({
  children,
  fullWidth = false,
  size = 'lg',
  className = '',
  ...props
}: ButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl sm:text-2xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative group overflow-hidden rounded-xl font-bold text-zinc-950 
        bg-gradient-to-b from-amber-400 to-amber-600 
        hover:from-amber-300 hover:to-amber-500
        shadow-[0_0_40px_-10px_rgba(245,158,11,0.5)]
        transition-all duration-300 flex items-center justify-center gap-2
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-257">
      <div className="absolute inset-0 bg-white/20 translate-y-[-100%] group-hover:translate-y-[100%] transition-transform duration-500 ease-in-out" data-id="element-258" />
      {children}
      <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-259" />
    </motion.button>;
}